// Libs
import React, { useState, useContext } from "react";
import { StoresContext, Stores } from "Globals/Stores";
import { useObserver, KeyValuePair, Grid, Else, FieldType, EditableInput } from "@shoothill/core";
import { Link as RouterLink } from "react-router-dom";
import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";
import { RadioSVG } from "Globals/Views/IconSVGs/RadioSVG";
import { RadioCheckedSVG } from "Globals/Views/IconSVGs/RadioCheckedSVG";
import { Button, Table, TableHead, TableBody, TableRow, TableContainer, TableCell, Box, Checkbox, Typography } from "@material-ui/core";
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import DateFnsUtils from "@date-io/date-fns";
import styled from "styled-components";
import { BinSVG } from "Globals/Views/IconSVGs/BinSVG";
import { CheckboxCheckedSVG } from "Globals/Views/IconSVGs/CheckboxCheckedSVG";
import { CheckboxSVG } from "Globals/Views/IconSVGs/CheckboxSVG";

// App
import { theme } from "Globals/Styles/AppTheme";
import IncomeDetailsViewModel from "Globals/ViewModels/FormSections/IncomeSavingsAndOutgoings/IncomeDetailsViewModel";
import MoneyGifterViewModel from "Globals/ViewModels/FormSections/IncomeSavingsAndOutgoings/MoneyGifterViewModel";
import ApplicationFormViewModel from "Globals/ViewModels/ApplicationFormViewModel";
import { CurrencyInput } from "Globals/Views/CurrencyInput";

// Styles
import { StyledButton } from "Globals/Styles/ButtonStyles";
import { Row } from "Globals/Styles/LayoutStyles";
import { CustomInput } from "Globals/Styles/AppStyling";

export const StyledAddButton = styled(StyledButton)`
    width: 32px;
    height: 32px;
    min-width: 32px;
    min-height: 32px;
    padding: 0px;
    margin: 0 0 1px 0;
`;
interface IProps {
    incomeDetailsViewModel: IncomeDetailsViewModel;
    applicationFormViewModel: ApplicationFormViewModel;
    isPrimary?: boolean;
}

export const MoneyGifterView: React.FC<IProps> = (props: IProps) => {
    const storesContext = useContext<Stores>(StoresContext);
    const [upsertViewModel] = useState(() => new MoneyGifterViewModel());
    return useObserver(() => (
        <>
            <Row style={{ alignItems: "center" }}>
                <CustomInput
                    style={{ marginTop: "6px" }}
                    label="Name of person gifting money"
                    placeHolder="Enter the name of the person gifting money"
                    viewModel={upsertViewModel}
                    fieldName="name"
                    shrink={true}
                    inputProps={{
                        disabled: upsertViewModel.IsLoading || props.applicationFormViewModel.model.isSubmitted || storesContext.Domain.SaveStore.isSaving,
                    }}
                />
                <CurrencyInput viewModel={upsertViewModel} label={"Total gifted money"} placeholder={"Enter total gifted money"} fieldName={"amount"} />

                {props.isPrimary && props.applicationFormViewModel.getSortedApplicantViewModels.length > 1 && (
                    <Box>
                        <Row style={{ alignItems: "center" }}>
                            <Checkbox
                                checked={upsertViewModel.getValue("sameForApplicantTwo")}
                                onChange={(e) => {
                                    upsertViewModel.handleCheckboxChange("sameForApplicantTwo", e.target.checked);
                                }}
                                icon={<CheckboxSVG />}
                                checkedIcon={<CheckboxCheckedSVG />}
                                disabled={props.applicationFormViewModel.model.isSubmitted}
                            />
                            <Typography variant="body1" style={{ fontWeight: "bold" }}>
                                Same for applicant 2
                            </Typography>
                        </Row>
                    </Box>
                )}

                <Box style={{ display: "flex", alignItems: "start", marginTop: "22px" }}>
                    <StyledAddButton
                        variant="contained"
                        disableElevation
                        onClick={() => upsertViewModel.stash(props.incomeDetailsViewModel)}
                        disabled={upsertViewModel.IsLoading || props.applicationFormViewModel.model.isSubmitted || storesContext.Domain.SaveStore.isSaving}
                    >
                        +
                    </StyledAddButton>
                </Box>
            </Row>

            {props.incomeDetailsViewModel.getSortedMoneyGifterViewModels.length > 0 && (
                <TableContainer>
                    <Table style={{ width: "100%" }} aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell>Name of person gifting money</TableCell>
                                <TableCell align="center">Total gifted money</TableCell>
                                {props.isPrimary && <TableCell align="center">Same for applicant 2</TableCell>}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {props.incomeDetailsViewModel.getSortedMoneyGifterViewModels.map((moneyGifter) => (
                                <TableRow key={moneyGifter.model.id}>
                                    <TableCell component="th" scope="moneyGifter">
                                        {moneyGifter.model.name}
                                    </TableCell>
                                    <TableCell align="center">£{moneyGifter.model.amount}</TableCell>
                                    {props.isPrimary && <TableCell align="center">{moneyGifter.getValue("sameForApplicantTwo") ? "Yes" : "No"}</TableCell>}
                                    <TableCell align="center">
                                        <Button
                                            onClick={() => {
                                                moneyGifter.delete(props.incomeDetailsViewModel, true);
                                            }}
                                        >
                                            <BinSVG />
                                        </Button>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            )}
        </>
    ));
};
